const store = (() => {
	function get(id) {
		try {
			const E = document.getElementById(id);
			return JSON.parse(E.innerHTML);
		} catch(e) {
			return null;
		}
	}

	return {
		pushStateSupport: (typeof history.pushState === "function"),
		pageTitle: document.title,
		error: "銭湯情報を読み込み中...",
		mapLoaded: false,
		bathFeatures: [],
		baths: [],
		cond: {},
		showResult: false,
		resutCount: 0,
		resultMode: null,
		results: [],
		position: "auto",
		currentShop: null,
		facilities: get("json-facilities") || [],
		bathFeatures: get("json-bath-features") || [],
	};
})();
